// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","meals":"Epb9PdHAGIa_","meals_singleMeal":"_2rTZu47_vvep"};